document.querySelectorAll('.custom-number-input').forEach((counter) => {
  const countMinus = counter.querySelector('.minus');
  const countPlus = counter.querySelector('.plus');
  const input = counter.querySelector('input');

  if (!countMinus || !countPlus || !input) return;

  const step = parseInt(input.dataset.step, 10) || 1;

  const normalizeValue = (value) => {
    const max = parseInt(input.dataset.max, 10) || 100;

    // eslint-disable-next-line no-restricted-globals,no-param-reassign
    value = isNaN(value) ? 0 : value;
    // eslint-disable-next-line no-param-reassign
    value = Math.round(value / step) * step; // Round to nearest step
    // eslint-disable-next-line no-param-reassign
    value = Math.min(Math.max(0, value), max); // Clamp between 0 and max
    return value;
  };

  // Update input value and dispatch 'change' event if needed
  const setValue = (value, fromInput = false) => {
    const newValue = normalizeValue(value);
    if (parseInt(input.value, 10) !== newValue) {
      input.value = newValue;
      if (!fromInput) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  };

  // Event listeners
  countMinus.addEventListener('click', (e) => {
    e.preventDefault();
    setValue(parseInt(input.value, 10) - step);
  });

  countPlus.addEventListener('click', (e) => {
    e.preventDefault();
    setValue(parseInt(input.value, 10) + step);
  });

  input.addEventListener('change', () => {
    setValue(parseInt(input.value, 10), true); // true → change event came from input
  });
});
